import React, { useState } from 'react';
import styled from 'styled-components';
import { AnimatePresence } from 'framer-motion';

import CurrentReviews from './current-reviews';
import ReviewModal from './review-modal';

const ProductReviewsContainer = styled.div`
    background-color: #f2f0eb;
    padding-bottom: 70px;
    position: relative;

    &.modal-open {
        z-index: 5000;
    }
`;

const ProductReviews = ({ handle, reviews }) => {
    const [isModalShowing, setIsModalShowing] = useState(false);
    return (
        <ProductReviewsContainer className={isModalShowing ? 'modal-open' : ''}>
            <CurrentReviews
                setIsModalShowing={setIsModalShowing}
                handle={handle}
                reviews={reviews}
            />
            <AnimatePresence>
                {isModalShowing && (
                    <ReviewModal
                        handle={handle}
                        isModalShowing={isModalShowing}
                        setIsModalShowing={setIsModalShowing}
                    />
                )}
            </AnimatePresence>
        </ProductReviewsContainer>
    );
};

export default ProductReviews;
